import { environment } from "../../environments/environment";

export const DICT_SETTINGS = "settings/dictionary/";
export const PARAMETERS = "parameters";

export const PUBLICATIONS = environment.apiUrl + "publications";
export const USER_INFO = environment.apiUrl + "user_info";
export const DICTIONARY = environment.apiUrl + DICT_SETTINGS + "params";
export const VALUE_TYPES = environment.apiUrl + DICT_SETTINGS + "value_type";
